<template>
  <v-container fluid grid-list-md style="padding: 30px;">
    <v-alert v-model="alert" dismissible type="warning">{{msgAlert}}</v-alert>
    <!-- Seleção de Empresa e Evento -->
    <v-row dense v-if="user.tipo == 'ADMIN' || user.tipo == 'NOTIFY'">
      <v-col cols="12" sm="12" md="6">
        <v-card outlined class="elevation-1 rounded mb-4">
          <v-card-text>
            <v-autocomplete
              outlined
              dense
              v-model="empresaSelecionada"
              :items="empresas"
              no-data-text="Nenhuma empresa encontrada"
              item-text="nome"
              item-value="id"
              label="Selecione a empresa"
              @input="carregaEventos"
              prepend-inner-icon="mdi-office-building"
              clearable
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" sm="12" md="6">
        <v-card outlined class="elevation-1 rounded mb-4">
          <v-card-text>
            <v-autocomplete
              outlined
              dense
              v-model="eventoSelecionado"
              :items="eventos"
              no-data-text="Nenhum evento encontrado"
              item-text="nome"
              item-value="id"
              label="Selecione o evento"
              @input="setEventoId"
              prepend-inner-icon="mdi-calendar-text"
              clearable
              :disabled="!empresaSelecionada"
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Seleção de Modelo de Mensagem -->
    <v-row dense v-if="eventoSelecionado">
      <v-col cols="12" sm="12" md="6" class="mx-auto">
        <v-card outlined class="elevation-1 rounded mb-4">
          <v-card-title class="secondary white--text subtitle-1">
            <v-icon left color="white">mdi-text-box-multiple</v-icon>
            <h4>Modelos de Mensagem</h4>
          </v-card-title>
          <v-card-text class="pt-3">
            <v-select
              outlined
              dense
              v-model="modeloSelecionado"
              :items="modelos"
              item-text="nome"
              item-value="id"
              label="Selecione um modelo"
              @change="aplicarModelo"
              return-object
              menu-props="{ maxHeight: '400'}"
              prepend-inner-icon="mdi-file-document-outline"
              :hint="modelos.length ? 'Selecione um modelo para usar' : 'Nenhum modelo disponível'"
              persistent-hint
            >
              <template v-slot:selection="{ item }">
                <v-chip small color="info" text-color="white">
                  {{ item.nome }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-item @click="aplicarModelo(data.item)" ripple>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon small left color="primary">{{ getTipoIcon(data.item.tipo) }}</v-icon>
                      {{ data.item.nome }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-truncate">
                      {{ data.item.mensagem ? data.item.mensagem.substring(0, 50) + '...' : '' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-row align="center">
                      <v-btn icon small class="mr-1" @click.stop="editarModelo(data.item)" title="Editar">
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn icon small @click.stop="excluirModelo(data.item)" title="Excluir">
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                    </v-row>
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-select>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Mensagem de Whatsapp -->
    <v-row justify="center" v-if="eventoSelecionado">
      <v-col cols="12" md="6">
        <v-card outlined class="elevation-2 rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-whatsapp</v-icon>
            <h4>Mensagem de WhatsApp</h4>
          </v-card-title>
          <v-card-text class="pt-4">
            <v-form>
              <v-select
                outlined
                dense
                v-model="whatsapp.tipo"
                :items="tipos"
                item-value="value"
                item-text="text"
                label="Tipo de Mensagem"
                prepend-inner-icon="mdi-format-list-text"
              ></v-select>

              <v-text-field 
                v-if="whatsapp.tipo != 'CERTIFICADO'"
                v-model="whatsapp.urlArquivo"
                label="URL do Arquivo"
                outlined
                @input="renderPreview"
                prepend-inner-icon="mdi-link-variant"
                clearable
                hint="Digite a URL completa do arquivo que deseja enviar"
              ></v-text-field>

              <v-text-field 
                v-if="whatsapp.tipo != 'CERTIFICADO'"
                v-model="condicao"
                label="Condição da Mensagem"
                outlined
                prepend-inner-icon="mdi-filter-outline"
                hint="Ex: [{'cpf':'111.222.333-44'}]"
                persistent-hint
              ></v-text-field>

              <v-text-field
                v-if="whatsapp.tipo != 'CERTIFICADO'"
                v-model="whatsapp.codMsgEnviada"
                label="Identificador da Mensagem"
                outlined
                prepend-inner-icon="mdi-identifier"
                hint="Código único para identificar esta mensagem"
                persistent-hint
              ></v-text-field>

              <v-card v-if="preview" class="mt-3 mb-3 pa-2" outlined>
                <v-card-title class="subtitle-1 py-1">
                  <v-icon left small color="primary">mdi-eye</v-icon>
                  Pré-visualização
                </v-card-title>
                <v-card-text class="text-center">
                  <v-img
                    v-if="isImage" 
                    :src="whatsapp.urlArquivo" 
                    class="preview-item rounded mx-auto" 
                    contain 
                  />
                  <video v-if="isVideo" 
                    :src="whatsapp.urlArquivo" 
                    controls 
                    class="preview-item rounded mx-auto"
                  ></video>
                  <v-btn v-if="isPDF" 
                    :href="whatsapp.urlArquivo" 
                    target="_blank" 
                    color="primary" 
                    class="preview-item my-2">
                    <v-icon left>mdi-file-pdf-box</v-icon>
                    Ver PDF
                  </v-btn>
                </v-card-text>
              </v-card>

              <v-textarea
                v-if="whatsapp.tipo != 'CERTIFICADO'"
                v-model="whatsapp.mensagem"
                label="Digite sua mensagem"
                rows="5"
                outlined
                counter
                prepend-inner-icon="mdi-message-text-outline"
                hint="Você pode usar {nome}, {email} e outros campos como variáveis"
                persistent-hint
              ></v-textarea>
            </v-form>
          </v-card-text>

          <v-divider></v-divider>
          
          <v-card-actions class="pa-4">
            <v-btn 
              color="primary" 
              v-if="whatsapp.tipo != 'CERTIFICADO'" 
              :disabled="!eventoSelecionado" 
              @click="openSaveModel"
              outlined
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar Modelo
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn 
              color="success" 
              :disabled="!eventoSelecionado" 
              @click="whatsapp.tipo != 'CERTIFICADO' ? enviarWhatsapp() : certificadoWhatsapp()"
              dark
              rounded
            >
              <v-icon left>{{whatsapp.tipo != 'CERTIFICADO' ? 'mdi-send' : 'mdi-certificate'}}</v-icon>
              {{formTitle}}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-col cols="12" md="4" lg="4">
        <v-card outlined>
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-bell-outline</v-icon>
            <h4>Notificações de Envio</h4>
          </v-card-title>
          <v-card-text>
            <div v-if="notifications.length">
              <v-container>
                <v-row>
                  <v-col v-for="notification in notifications" :key="notification.codigo" cols="12">
                    <v-card class="mb-3 notification-card">
                      <v-card-title class="py-2 px-4 subtitle-1 d-flex justify-space-between align-center">
                        <div>
                          <v-icon small left color="primary">mdi-office-building</v-icon>
                          {{ notification.nomeEmpresa }}
                        </div>
                        <v-btn icon x-small color="red" @click="removerNotificacao(notification.codigo)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text class="py-2">
                        <v-row no-gutters>
                          <v-col cols="12" class="mb-1">
                            <v-icon small left color="primary">mdi-calendar-text</v-icon>
                            <span class="font-weight-medium">{{ notification.nomeEvento }}</span>
                          </v-col>
                          <v-col cols="12" class="mb-1">
                            <v-icon small left color="purple">mdi-barcode</v-icon>
                            <span class="caption">Código: <b>{{ notification.codigo }}</b></span>
                          </v-col>
                          <v-col cols="6" class="mb-1">
                            <v-icon small left color="green">mdi-clock-start</v-icon>
                            <span class="caption">Início: {{ formatarHora(notification.horaInicio) }}</span>
                          </v-col>
                          <v-col cols="6" class="mb-1">
                            <v-icon small left color="orange">mdi-clock-outline</v-icon>
                            <span class="caption">Decorrido: {{ notification.tempoDecorrido }}</span>
                          </v-col>
                          <v-col cols="6" class="mb-1">
                            <v-icon small left color="blue">mdi-clock-end</v-icon>
                            <span class="caption">Término: {{ formatarHora(notification.estimativaTermino) }}</span>
                          </v-col>
                          <v-col cols="6" class="mb-1">
                            <v-icon small left color="deep-purple">mdi-counter</v-icon>
                            <span class="caption">{{ notification.progresso }} / {{ notification.total }}</span>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-progress-linear
                        v-if="notification.total > 0"
                        :value="(notification.progresso / notification.total) * 100"
                        height="10"
                        rounded
                        :color="getProgressColor(notification.progresso, notification.total)"
                      >
                        <strong>{{ Math.ceil((notification.progresso / notification.total) * 100) }}%</strong>
                      </v-progress-linear>
                      
                      <v-card-text class="pt-2 pb-0 text-center" style="margin: 6px 0px 6px 0px;">
                        <v-chip small color="success" text-color="white" v-if="notification.progresso < notification.total && !notification.cancelado">
                          <v-icon left small>mdi-send-clock</v-icon>
                          Enviando mensagens...
                        </v-chip>
                        <v-chip small color="error" text-color="white" v-else-if="notification.cancelado">
                          <v-icon left small>mdi-cancel</v-icon>
                          Envio cancelado
                        </v-chip>
                        <v-chip small color="success" text-color="white" v-else>
                          <v-icon left small>mdi-check-circle</v-icon>
                          Envio concluído
                        </v-chip>
                      </v-card-text>
                      
                      <v-card-actions v-if="notification.progresso < notification.total && !notification.cancelado">
                        <v-btn 
                          color="error" 
                          small 
                          outlined 
                          block
                          @click="cancelarEnvio(notification.codigo)"
                          :disabled="notification.progresso >= notification.total || notification.cancelado"
                        >
                          <v-icon left small>mdi-cancel</v-icon>
                          Cancelar Envio
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </div>
            <div v-else class="text-center pa-4 grey--text">
              <v-icon large color="grey lighten-1">mdi-bell-off-outline</v-icon>
              <div class="mt-2">Nenhuma notificação de envio encontrada.</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Envios com erro -->
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card outlined v-if="errosEnvio.length > 0">
          <v-card-title>
            <span class="text-h6">Envios com Erro</span>
          </v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="erro in errosEnvio" :key="erro.telefone">
                <v-list-item-content>
                  <v-list-item-title>{{ erro.nome }}</v-list-item-title>
                  <v-list-item-subtitle>{{ erro.telefone }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Salvar Modelo de Mensagem -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="700px">
        <v-card class="rounded-lg">
          <v-card-title class="primary white--text">
            <v-icon left color="white">mdi-content-save-outline</v-icon>
            <span class="text-h5">{{ modeloEditado ? 'Editar Modelo' : 'Salvar Modelo de Mensagem' }}</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4">
            <v-container>
              <v-row dense>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="modeloMensagem.nome"
                    label="Nome do Modelo"
                    outlined
                    dense
                    prepend-inner-icon="mdi-label-outline"
                    :rules="[v => !!v || 'Nome é obrigatório']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    dense
                    v-model="modeloMensagem.tipo"
                    :items="tipos"
                    item-value="value"
                    item-text="text"
                    label="Tipo de Mensagem"
                    prepend-inner-icon="mdi-format-list-text"
                    :rules="[v => !!v || 'Tipo é obrigatório']"
                  >
                    <template v-slot:selection="{ item }">
                      <v-icon small left>{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>
                    <template v-slot:item="{ item }">
                      <v-icon small left>{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>
                  </v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="modeloMensagem.urlArquivo"
                    label="URL do Arquivo"
                    outlined
                    dense
                    prepend-inner-icon="mdi-link-variant"
                    hint="URL completa do arquivo que será enviado"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="condicao"
                    label="Condição da Mensagem"
                    outlined
                    dense
                    prepend-inner-icon="mdi-filter-outline"
                    hint="Ex: [{'cpf':'111.222.333-44'}]"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="modeloMensagem.codMsgEnviada"
                    label="Identificador da Mensagem"
                    outlined
                    dense
                    prepend-inner-icon="mdi-identifier"
                    :rules="[v => !!v || 'Identificador é obrigatório']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea
                    v-model="modeloMensagem.mensagem"
                    label="Digite sua mensagem"
                    rows="4"
                    outlined
                    dense
                    prepend-inner-icon="mdi-message-text-outline"
                    hint="Você pode usar {nome}, {email} e outros campos como variáveis"
                    persistent-hint
                    :rules="[v => !!v || 'Mensagem é obrigatória']"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-btn color="grey darken-1" text @click="dialog = false">
              <v-icon left>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="salvarModelo">
              <v-icon left>mdi-content-save</v-icon>
              {{ modeloEditado ? 'Atualizar' : 'Salvar' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref="chamaSnackbar"/>
  </v-container>
</template>

<script>
  import { baseApiUrl, baseApiWsUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import Loading from 'vue-loading-overlay';
  import axios from 'axios'
  import { mapState } from 'vuex'
  import io from 'socket.io-client'
  export default {
    components: { Snackbar, Loading },
    data: () => ({
      msgAlert: '',
      alert: false,
      fullPage: true,
      isLoading: false,
      dialog: false,
      confirmDialog: false, 
      modeloSalvo: false,
      modeloEditado: false,
      empresaSelecionada: '',
      eventoSelecionado: '',
      empresas: [],
      eventos: [],
      modelos: [],
      modeloSelecionado: '',
      tipos: [
        { value: "TEXTO", text: "Texto Simples", icon: "mdi-text" },
        { value: "AUDIO", text: "Áudio", icon: "mdi-music-note" },
        { value: "VIDEO", text: "Vídeo", icon: "mdi-video" },
        { value: "IMAGEM", text: "Imagem", icon: "mdi-image" },
        { value: "ANEXO", text: "Anexo", icon: "mdi-attachment" },
        { value: "CERTIFICADO", text: "Certificado", icon: "mdi-certificate" }
      ],
      whatsapp: {
        eventoId: "",
        condicao: "",
        mensagem: "",
        tipo: "",
        urlArquivo: "",
        codMsgEnviada: "",
      },
      whatsappDefault: {
        eventoId: "",
        condicao: "",
        mensagem: "",
        tipo: "",
        urlArquivo: "",
        codMsgEnviada: "",
      },
      modeloMensagem: {},
      condicao: '[{"cpf":"111.222.333-44"}]',
      preview: false,
      isImage: false,
      isVideo: false,
      isPDF: false,
      errosEnvio: [],
			socket: null,
			notifications: [],
      exibeProgresso: false,
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.whatsapp.tipo != 'CERTIFICADO' ? 'Enviar via WhatsApp ' : 'Gerar Certificado'
      },
    }),

    mounted() {
      this.connectSocketIo();
      if (this.user.tipo == 'ADMIN' || this.user.tipo == 'NOTIFY') {
        this.carregaEmpresas()
        this.carregaModelo()
      }
    },

    beforeDestroy() {
      if (this.socket) {
        this.socket.disconnect();
      }
    },

    methods: {
      async carregaEmpresas() {
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC", "fields":{"nome": true, "id": true}}&access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            if (response.data.length > 0) {
              this.empresas = response.data
            }
          });
      },

      async carregaEventos(empresaId) {
        if (typeof empresaId === 'object' && empresaId !== null) {
          // Se for um objeto, use o ID
          empresaId = empresaId.id;
        }
        
        await axios.get(baseApiUrl + 'Eventos?filter={"where":{"empresaId":"' + empresaId + '"}}&access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            if (response.data) {
              this.eventos = response.data
            }
          });
      },

      async carregaModelo() {
        await axios.get(baseApiUrl + 'ModelosMensagens?access_token=' + sessionStorage.getItem('accToken'))
          .then(response => {
            if (response.data) {
              this.modelos = response.data
            }
          });
      },

      aplicarModelo(modelo) {
        if (!modelo) return;
        
        // Se for apenas o ID, buscar o modelo completo
        if (typeof modelo === 'string') {
          modelo = this.modelos.find(m => m.id === modelo);
        }
        
        if (modelo) {
          this.whatsapp.tipo = modelo.tipo;
          this.whatsapp.urlArquivo = modelo.urlArquivo;
          this.whatsapp.mensagem = modelo.mensagem;
          this.whatsapp.codMsgEnviada = modelo.codMsgEnviada;
          this.condicao = modelo.condicao || ''; 
          this.renderPreview();
        }
      },

      async salvarModelo() {
        if (!this.modeloMensagem.nome || !this.modeloMensagem.tipo || !this.modeloMensagem.urlArquivo || !this.modeloMensagem.codMsgEnviada || !this.modeloMensagem.mensagem) {
          this.$refs.chamaSnackbar.snack("#F44336", "Por favor, preencha todos os campos!", "ATENÇÃO");
          return;
        }

        try {
          this. salvarModelo ? 
            await axios.put(baseApiUrl + 'ModelosMensagens?access_token=' + sessionStorage.getItem("accToken"),this.modeloMensagem) :
            await axios.post(baseApiUrl + 'ModelosMensagens?access_token=' + sessionStorage.getItem("accToken"),this.modeloMensagem);
          this.modeloSalvo = true;
          this.dialog = false;
          this.modeloEditado = false;
          this.$refs.chamaSnackbar.snack("#4CAF50", "Modelo salvo com sucesso!", "SUCESSO");
        } catch (error) {
          this.$refs.chamaSnackbar.snack("#F44336", "Erro ao salvar o modelo!", "ERRO");
        }
        this.carregaModelo()
      },

      async enviarWhatsapp() {
        if (!this.whatsapp.tipo || !this.whatsapp.mensagem || !this.empresaSelecionada || !this.eventoSelecionado) {
          this.$refs.chamaSnackbar.snack("#F44336", 'Por favor, preencha todos os campos!', 'ATENÇÃO');
          return;
        }

        // Garantir que eventoId seja um ID e não objeto
        if (typeof this.whatsapp.eventoId === 'object' && this.whatsapp.eventoId !== null) {
          this.whatsapp.eventoId = this.whatsapp.eventoId.id;
        }

        this.exibeProgresso = true;
        this.whatsapp.condicao = JSON.parse(this.condicao);
        
        try {
          const response = await axios.post(
            `${baseApiUrl}notificacoes/noticacoesWhatsappEvento`,
            this.whatsapp,
            { params: { access_token: sessionStorage.getItem('accToken') } }
          );
          
          if (response.data) {
            const { total, qtdSucesso, qtdErro, envios, mensagem } = response.data;
            this.msgAlert = 'Enviando mensagens, verifique o progresso em Notificações de Envio!'

            if (mensagem) {
              this.$refs.chamaSnackbar.snack("#F9A825", mensagem, "MENSAGEM DO SERVIDOR");
            } else {
              this.$refs.chamaSnackbar.snack("#F9A825", `Total: ${total}, Sucesso: ${qtdSucesso}, Erros: ${qtdErro}`, "MENSAGENS ENVIADAS");

              if (qtdErro > 0) {
                const erros = envios.filter(envio => !envio.envio);
                this.errosEnvio = erros;

                let msgErro = 'Falha ao enviar para:\n';
                erros.forEach(envio => {
                  msgErro += `${envio.nome} - ${envio.telefone}\n`;
                });

                this.$refs.chamaSnackbar.snack("#F44336", msgErro, "ERRO");
              } else {
                this.errosEnvio = [];
              }
            }
          }
        } catch (error) {
          this.$refs.chamaSnackbar.showSnackbar('Ocorreu um erro ao enviar o WhatsApp. Verifique os dados e tente novamente.', 'error');
        }
      },

      async certificadoWhatsapp() {
        this.isLoading = true;     
        if (!this.eventoSelecionado) {
          this.isLoading = false;
          this.$refs.chamaSnackbar.snack('red', 'Evento não selecionado!', 'ERRO');
          return          
        }
        
        let eventoId = this.eventoSelecionado;
        // Garantir que estamos usando somente o ID
        if (typeof eventoId === 'object' && eventoId !== null) {
          eventoId = eventoId.id;
        }
          
        try {
          let response = await axios.post(`${baseApiUrl}eventos/gerarCertificado`,{eventoId: eventoId},{params: { access_token: sessionStorage.getItem('accToken')}});
          if (response.data) {
            this.$refs.chamaSnackbar.snack('green','Certificados gerados!', 'GERADO');
          }
        } catch (error) {
          this.$refs.chamaSnackbar.snack('red', 'Ocorreu um erro ao enviar o certificado.', 'ERRO');
        } finally {
          this.isLoading = false;
        }
      },

      editarModelo(modelo) {
        this.modeloMensagem = { ...modelo };
        this.dialog = true;
        this.modeloEditado = true;
      },

      excluirModelo(modelo) {
        if (confirm("Tem certeza que deseja excluir este modelo?")) {
          axios.delete(baseApiUrl + 'ModelosMensagens/' + modelo.id + '?access_token=' + sessionStorage.getItem('accToken'))
            .then(() => {
              this.$refs.chamaSnackbar.snack("#4CAF50", "Modelo excluído com sucesso!", "SUCESSO");
              this.carregaModelo();
            })
            .catch(() => {
              this.$refs.chamaSnackbar.snack("#F44336", "Erro ao excluir o modelo!", "ERRO");
            });
        }
      },

      openSaveModel() {
        this.modeloMensagem = {
          tipo: this.whatsapp.tipo,
          urlArquivo: this.whatsapp.urlArquivo,
          mensagem: this.whatsapp.mensagem,
          codMsgEnviada: this.whatsapp.codMsgEnviada,
          condicao: this.condicao
        };
        
        this.confirmDialog = false;
        this.dialog = true;
      },

      renderPreview() {
        const url = this.whatsapp.urlArquivo;
        if (!url) {
          this.preview = false;
          return;
        }

        // Resetar os estados
        this.isImage = false;
        this.isVideo = false;
        this.isPDF = false;

        // Verifica o tipo do arquivo pelo formato da URL
        if (url.match(/\.(jpeg|jpg|gif|png)$/)) {
          this.isImage = true;
        } else if (url.match(/\.(mp4|webm|ogg)$/)) {
          this.isVideo = true;
        } else if (url.match(/\.pdf$/)) {
          this.isPDF = true;
        }

        this.preview = true; // Habilitar a prévia
      },

      setEventoId(eventoId) {
        if (typeof eventoId === 'object' && eventoId !== null) {
          // Se for um objeto, use o ID
          this.whatsapp.eventoId = eventoId.id;
        } else {
          this.whatsapp.eventoId = eventoId;
        }
      },

      connectSocketIo() {
        this.socket = io(baseApiWsUrl, {
          reconnection: true,
          reconnectionAttempts: 10,
          reconnectionDelay: 1000,
          transports: ['polling', 'websocket'],
          upgrade: false,
          forceNew: true
        });

        this.socket.on('connect', () => {
          // console.log('Conexão estabelecida com o servidor');
        });

        this.socket.on('connect_error', (error) => {
          // console.error('Erro de conexão:', error.message);
          this.$refs.chamaSnackbar.snack("#F44336", "Erro na conexão WebSocket: " + error.message, "ERRO");
        });

        this.socket.on('@whatsapp', (data) => {
          const existingNotificationIndex = this.notifications.findIndex(notification => notification.codigo === data.codigo);
          
          // Garantir que a propriedade cancelado está definida
          if (!data.hasOwnProperty('cancelado')) {
            data.cancelado = false;
          }
          
          if (existingNotificationIndex !== -1) {
            this.$set(this.notifications, existingNotificationIndex, { ...this.notifications[existingNotificationIndex], ...data });
          } else {
            this.$set(this.notifications, this.notifications.length, data);
          }
          // console.log('Mensagem do servidor:', data);
        });

        this.socket.on('disconnect', () => {
          // console.log('Desconectado do servidor');
        });
      },

      formatarHora(dataHora) {
        const date = new Date(dataHora);

        const horas = String(date.getHours()).padStart(2, '0');
        const minutos = String(date.getMinutes()).padStart(2, '0');
        const segundos = String(date.getSeconds()).padStart(2, '0');

        return `${horas}:${minutos}:${segundos}`;
      },

      removerNotificacao(codigo) {
        this.notifications = this.notifications.filter(notification => notification.codigo !== codigo);
      },

      getProgressColor(progresso, total) {
        if (progresso === total) {
          return 'green';
        } else if (progresso > 0 && progresso < total) {
          return 'yellow';
        } else {
          return 'red';
        }
      },

      getTipoIcon(tipo) {
        const tipoIcon = this.tipos.find(t => t.value === tipo);
        return tipoIcon ? tipoIcon.icon : 'mdi-file-question';
      },

      getNomeEmpresa(empresaId) {
        if (!empresaId) return '';
        const empresa = this.empresas.find(emp => emp.id === empresaId);
        return empresa ? empresa.nome : '';
      },
      
      getNomeEvento(eventoId) {
        if (!eventoId) return '';
        const evento = this.eventos.find(evt => evt.id === eventoId);
        return evento ? evento.nome : '';
      },

      async cancelarEnvio(codMsgEnviada) {
        if (!codMsgEnviada) {
          this.$refs.chamaSnackbar.snack("#F44336", "Código da mensagem não informado!", "ERRO");
          return;
        }

        try {
          this.isLoading = true;
          const response = await axios.post(
            `${baseApiUrl}notificacoes/pararEnvioWhatsapp`,
            { codMsgEnviada },
            { params: { access_token: sessionStorage.getItem('accToken') } }
          );
          
          if (response.data && response.data.sucesso) {
            this.$refs.chamaSnackbar.snack("#4CAF50", "Envio cancelado com sucesso!", "SUCESSO");
            
            // Atualizar o status da notificação na interface
            const notificacaoIndex = this.notifications.findIndex(n => n.codigo === codMsgEnviada);
            if (notificacaoIndex !== -1) {
              this.$set(this.notifications, notificacaoIndex, {
                ...this.notifications[notificacaoIndex],
                cancelado: true
              });
            }
          } else {
            this.$refs.chamaSnackbar.snack("#F44336", "Não foi possível cancelar o envio!", "ERRO");
          }
        } catch (error) {
          this.$refs.chamaSnackbar.snack("#F44336", "Erro ao cancelar o envio: " + (error.response.data.error.message), "ERRO");
        } finally {
          this.isLoading = false;
        }
      },

    },
  }
</script>

<style>
.preview-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
}

.preview-item {
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  max-width: 500px;
  max-height: 350px;
  margin: 0 auto;
}

video.preview-item {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.notification-card {
  transition: all 0.3s ease;
  border-left: 4px solid #1976D2;
}

.notification-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.v-card {
  transition: all 0.3s ease;
}

.v-card.elevation-2:hover {
  box-shadow: 0 6px 12px rgba(0,0,0,0.15) !important;
}

.v-btn {
  text-transform: none;
  letter-spacing: 0.5px;
}

.v-btn.success {
  background-color: #4CAF50 !important;
}

.caption {
  font-size: 0.75rem;
  font-weight: 400;
}

.v-chip {
  font-weight: 500;
}

.v-card-title.primary {
  background-color: #1976D2 !important;
}

.v-card-title.secondary {
  background-color: #424242 !important;
}
</style>
